import { createRoute } from "@tanstack/react-router";

import PunttDashboardLoader from "./loader";
import PunttDashboardView from "./view";

import { getGuidelines } from "../../services/brand-guidelines";
import { getRecentReviews } from "../../services/reviews";
import { requiresAuth } from "../../utils/auth";
import { authLayoutRoute } from "../auth-layout/route";

export const indexRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "/",
  beforeLoad() {
    requiresAuth();
  },
  async loader({ context }) {
    const { queryClient } = context;

    const data = await queryClient.fetchQuery({
      queryKey: ["brand-guidelines"],
      queryFn: getGuidelines,
    });

    const recents = await queryClient.fetchQuery({
      queryKey: ["workflows", "recents"],
      queryFn: () => getRecentReviews({ limit: "3" }),
    });

    return {
      aiPersonas: data?.aiPersonas ?? [],
      recents: recents ?? [],
    };
  },
  component: PunttDashboardView,
  // We make this the new loader? I dunno... Better than what we have.
  pendingComponent: PunttDashboardLoader,
});
